export const stateChangeIn = (imageDate?: Date): number => {
  const scheduledIn = imageDate ? imageDate.getTime() : 1;
  return Math.ceil((scheduledIn - Date.now()) / (1000 * 60 * 60 * 24));
};
